import { EventEmitter, SimpleChanges } from '@angular/core';
import { ITEM_TYPE_INFO_MAP } from 'Angular/features/components/saved-items/open-item-modal/constants';
import { SCATTER_PLOT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { SavedItemType } from 'Angular/features/components/saved-items/enums/saved-item-type.enum';
import { OpenItemModalAction } from 'Angular/features/components/saved-items/open-item-modal/enums/open-item-modal-action.enum';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import equal from 'Angular/utils/equal/deep-equal';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../apps/entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i4 from "../../../../loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../modals/modal-base/components/simple-modal-header.component";
import * as i7 from "Angular/features/components/saved-items/open-item-modal/components/open-item-tabs/open-item-tabs.component";
function OpenItemModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 6);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function OpenItemModalComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ycn-open-item-tabs", 7);
    i0.ɵɵlistener("doActionOnItemHandler", function OpenItemModalComponent_ng_container_4_Template_ycn_open_item_tabs_doActionOnItemHandler_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.doActionOnItem($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ownItems", ctx_r1.ownItems)("sharedItems", ctx_r1.sharedItems)("sharedWithMeEnabled", ctx_r1.sharedWithMeEnabled)("selectOnly", ctx_r1.selectOnly)("savedItemType", ctx_r1.savedItemType);
} }
function OpenItemModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵelement(2, "span", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
/**
 * Open Item Modal Component
 *
 * this modal is used for opening saved items of various types such as metric sets, fund charts, company screens,
 * comp tables, fund screens, scoring models, and time series tables
 *
 * Input Properties:
 *  items: ShareableItem[] to be displayed in the modal
 *  selectOnly: boolean whether items should be able to be edited or deleted
 *  savedItemType: SavedItemType type of the items being displayed
 *
 * Output Properties:
 *  itemDeletionHandler: EventEmitter<number> that emits the id if an item is deleted
 *  itemSelectionHandler: EventEmitter<ShareableItem> that emits the item if one is selected
 *  showEditModalHandler: EventEmitter<ShareableItem> that emits the item if one is edited
 */
export class OpenItemModalComponent {
    constructor(featureService) {
        this.featureService = featureService;
        this.selectOnly = false;
        this.sharedWithMeEnabled = true;
        this.itemDeletionHandler = new EventEmitter();
        this.itemSelectionHandler = new EventEmitter();
        this.showEditModalHandler = new EventEmitter();
        this.ownItems = [];
        this.sharedItems = [];
        this.itemTypeInfo = null;
        this.loading = false;
        this.modalOpen = false;
        this.saveItemsLabel = '';
    }
    ngOnInit() {
        this.setItemTypeInfo(this.savedItemType);
    }
    ngOnChanges(changes) {
        if (changes.items && changes.items.currentValue) {
            // Filter items into own items and shared items when items change
            const newOwnItems = this.items.filter((item) => !item.sharing || item.sharing.is_owner);
            if (!equal(this.ownItems, newOwnItems))
                this.ownItems = newOwnItems;
            const newSharedItems = this.items.filter((item) => item.sharing && !item.sharing.is_owner);
            if (!equal(this.sharedItems, newSharedItems))
                this.sharedItems = newSharedItems;
            this.setItemTypeInfo(this.savedItemType);
        }
    }
    doActionOnItem(itemAndAction) {
        if (itemAndAction.item) {
            switch (itemAndAction.actionType) {
                case OpenItemModalAction.SELECT:
                    this.closeModal();
                    this.itemSelectionHandler.emit(itemAndAction.item);
                    break;
                case OpenItemModalAction.EDIT:
                    this.closeModal();
                    this.showEditModalHandler.emit(itemAndAction.item);
                    break;
                case OpenItemModalAction.DELETE:
                    this.itemDeletionHandler.emit(itemAndAction.item.id);
                    break;
                default:
                    break;
            }
        }
    }
    setItemTypeInfo(itemType) {
        this.itemTypeInfo = ITEM_TYPE_INFO_MAP[itemType];
        if (Object.keys(this.itemTypeInfo).length) {
            this.saveItemsLabel = `Open Saved ${this.itemTypeInfo.singularLabel}`;
        }
    }
    closeModal() {
        this.modalOpen = false;
    }
    openModal() {
        if (this.savedItemType === SavedItemType.SCATTER_PLOT &&
            !this.featureService.userHasFeatures([SCATTER_PLOT_FEATURE])) {
            this.featureNeededComponent.openModal(SCATTER_PLOT_FEATURE);
        }
        else {
            this.modalOpen = true;
        }
    }
}
OpenItemModalComponent.ɵfac = function OpenItemModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OpenItemModalComponent)(i0.ɵɵdirectiveInject(i1.FeatureService)); };
OpenItemModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OpenItemModalComponent, selectors: [["ycn-open-item-modal"]], viewQuery: function OpenItemModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { items: "items", selectOnly: "selectOnly", savedItemType: "savedItemType", sharedWithMeEnabled: "sharedWithMeEnabled", errorMessage: "errorMessage" }, outputs: { itemDeletionHandler: "itemDeletionHandler", itemSelectionHandler: "itemSelectionHandler", showEditModalHandler: "showEditModalHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 8, consts: [[3, "closeModalHandler", "modalBaseClass", "extraModalClasses", "open"], [3, "closeModalHandler", "header", "showUnsavedStatus"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], [4, "ngIf"], ["class", "modal-footer user-select-none", 4, "ngIf"], [3, "loaderMessage"], [3, "doActionOnItemHandler", "ownItems", "sharedItems", "sharedWithMeEnabled", "selectOnly", "savedItemType"], [1, "modal-footer", "user-select-none"], [1, "popupFooter"], [1, "text-red", 3, "textContent"]], template: function OpenItemModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function OpenItemModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function OpenItemModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, OpenItemModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 3)(4, OpenItemModalComponent_ng_container_4_Template, 2, 5, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, OpenItemModalComponent_div_5_Template, 3, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("extraModalClasses", "modal-no-border user-select-none")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.saveItemsLabel)("showUnsavedStatus", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, dependencies: [i2.NgIf, i3.FeatureNeededComponent, i4.LoadingSymbolComponent, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent, i7.OpenItemTabsComponent], encapsulation: 2 });
